import { render, staticRenderFns } from "./HeZhuList.vue?vue&type=template&id=67358fbf&"
import script from "./HeZhuList.vue?vue&type=script&lang=js&"
export * from "./HeZhuList.vue?vue&type=script&lang=js&"
import style0 from "./HeZhuList.vue?vue&type=style&index=0&id=67358fbf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports